import { useCallback, useEffect, useState } from "react";
import { CheckCircle2, FileText } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { EmptyState, PageHeader, StatusBadge } from "@/components/shared/Common";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { openPdf } from "@/pages/prevencion/PrevCommon";

export default function MyDocs() {
  const [list, setList] = useState(null);
  const [opened, setOpened] = useState({});
  const load = useCallback(() => api.get("/iso/my-docs").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const read = async (d) => { await openPdf(`/iso/docs/${d.id}/file`); setOpened({ ...opened, [d.id]: true }); };
  const ack = async (d) => { try { await api.post(`/iso/docs/${d.id}/ack`); toast.success("Toma de conocimiento registrada"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const pending = (list || []).filter((d) => !d.acked_at).length;
  return (
    <div data-testid="my-docs-page">
      <PageHeader eyebrow="ISO / Gestión documental" title="Mis documentos" subtitle={list ? `${pending} documento(s) pendiente(s) de lectura. Ábralo, léalo y confirme.` : ""} />
      <div className="space-y-3">{!list ? "Cargando…" : list.length === 0 ? <div className="syc-card"><EmptyState title="No tiene documentos asignados" /></div> : list.map((d) => (
        <div key={d.id} data-testid={`my-doc-${d.id}`} className="syc-card p-4 flex flex-wrap items-center gap-3">
          <FileText className="text-[#258F00]" size={22} />
          <div className="flex-1 min-w-0"><div className="font-bold">{d.code} · {d.title} <span className="text-xs font-normal text-[#5b6656]">v{d.version} · {d.type}</span></div><div className="text-xs text-[#5b6656]">{d.change_summary}</div></div>
          {d.acked_at ? <StatusBadge status="activo" label={`Leído ${fmtDateTime(d.acked_at)}`} /> : <>
            <Button data-testid={`my-doc-open-${d.id}`} variant="outline" className="rounded-full" onClick={() => read(d)}>Abrir</Button>
            <Button data-testid={`my-doc-ack-${d.id}`} className="rounded-full" disabled={!opened[d.id]} onClick={() => ack(d)}><CheckCircle2 size={15} className="mr-1" />He leído y comprendido</Button></>}
        </div>))}</div>
    </div>
  );
}
